import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import _keyBy from 'lodash/keyBy';
import _find from 'lodash/find';

import * as api from '~/Services/Service';
import Loading from '~/Components/Loading';
import {
  applyFilter,
  selecionarEmpreendimento,
} from '~/Store/Prospecto/actions';

import AuthStorage from '~/Utils/AuthStorage';
import {
  STATUS_ETAPAS_PROSPECTOS,
  STATUS_ETAPAS_PROSPECTOS_TERRENO_CONSTRUCAO,
} from '~/constant';

import ProspectosNavbar from '~/Components/Prospectos/ProspectosNavbar';
import ModalAdicionarProspecto from '~/Components/Prospectos/ModalAdicionarProspecto';
import KanbanBoard from '~/Components/Kanban/KanbanBoard/KanbanBoard';
import CardProspecto from '~/Components/Kanban/CardProspecto/CardProspecto';
import { toast } from 'react-toastify';
import { REGRA_FLUXOGRAMA_ETAPA } from '~/constant';
import { Modal, Button } from 'react-bootstrap';

const USUARIOS_GITECH = [2046, 1567, 1431];
const isUsuarioGitech = () => {
  const user = AuthStorage.getUser();
  return user && USUARIOS_GITECH.includes(user.usuario);
};

class DashboardProspecto extends Component {
  state = {
    isSearchActive: false,
    carregandoProspectos: false,
    carregandoEtapas: true,
    expandirCorretores: false,
    filtros: {
      pagina_atual: 1,
    },
    prospectos: null,
    prospectoAtivo: null,
    contador: 0,
    corretores: [],
    corretoresSelecionaveis: [],
    prospectoCarregado: null,
    codigoProspectoEtapa: null,
    quantidadeProspectos: null,
    etapaSelecionada: {},
    editandoProspecto: false,
    tipoFiltroEtapa: isUsuarioGitech() ? 'etapaProspectoTerrenoConstrucao' : 'etapaProspectoPadrao',
    layoutSelecionado: AuthStorage.isCorretor() ? 'corretor' : 'geral',
    etapasTerrenoConstrucao: null,
    codigoEtapaTerrenoConstrucao: null,
    etapaTerrenoConstrucaoSelecionada: {},
    etapasProspectos: {},
    statusEtapaProspectoTerrenoConstrucao: {},
    modal: {
      show: false,
      etapa: '',
      tipo: '',
    },
    loadingEtapa: '',
    updatingCards: {},
    ordenacaoColunas: {},
  };

  defaultValues = {
    tipo_filtro: 'nome',
    filtro: '',
    codigo_gerente: '',
    codigo_corretor: '',
    codigo_empreendimento: '',
    codigo_prospecto_etapa: '',
    data_inicial: '',
    data_final: '',
    tipo_pasta: '',
    origem: '',
    flag_represado_bolsao: false,
    is_setclub: '',
    filtro_side_bar: '',
  };

  componentDidMount() {
    this.setState({}, () => {
      const etapasProspectos = STATUS_ETAPAS_PROSPECTOS.map(etapa => ({
        ...etapa,
        pagina_atual: 1,
      }));

      const statusEtapaProspectoTerrenoConstrucao = STATUS_ETAPAS_PROSPECTOS_TERRENO_CONSTRUCAO.map(
        etapa => ({
          ...etapa,
          pagina_atual: 1,
        })
      );

      const ordenacaoInicial = {};
      STATUS_ETAPAS_PROSPECTOS.forEach(etapa => {
        ordenacaoInicial[etapa.codigo] = 'asc';
      });
      STATUS_ETAPAS_PROSPECTOS_TERRENO_CONSTRUCAO.forEach(etapa => {
        ordenacaoInicial[etapa.codigo] = 'asc';
      });

      this.setState({
        etapasProspectos,
        statusEtapaProspectoTerrenoConstrucao,
        ordenacaoColunas: ordenacaoInicial,
      });
      let filtros = {
        ...this.props.filtro,
        quantidade_por_consulta: 50,
      };
      if (this.state.tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao') {
        filtros.apenas_terreno_construcao = true;
      }
      this.obterDados(filtros);
      if (this.props.corretores.length > 0) {
        this.atualizaCorretores();
      }
    });

    this.handleStorageChange = e => {
      if (e.key === 'kanban_reload_trigger' && e.newValue) {
        this.recarregarKanban().catch(error => {
          toast.error(
            error && error.message
              ? error.message
              : 'Erro ao recarregar o kanban.'
          );
        });
      }
    };
    window.addEventListener('storage', this.handleStorageChange);
  }

  componentWillUnmount() {
    if (this.handleStorageChange) {
      window.removeEventListener('storage', this.handleStorageChange);
    }
  }

  onChangeLayout = value => {
    this.setState({ layoutSelecionado: value }, () => {
      const filtros = {
        ...this.state.filtros,
        quantidade_por_consulta: 0,
        codigo_prospecto_etapa: '',
        codigo_etapa_terreno_construcao: '',
        filtrar_prospectos_ja_inclusos: '',
        quantidade_por_etapa: 0,
        tipo_visao: value,
      };

      this.setState(
        {
          contador: 0,
          prospectos: null,
          carregandoEtapas: true,
        },
        () => {
          this.obterDados(filtros, true);
        }
      );
    });
  };

  recarregarKanban = () => {
    const filtros = {
      ...this.state.filtros,
      tipo_visao: this.state.layoutSelecionado,
    };

    return new Promise((resolve, reject) => {
      this.setState(
        {
          carregandoEtapas: true,
          prospectos: null,
        },
        () => {
          this.obterDados(filtros, true)
            .then(resolve)
            .catch(reject);
        }
      );
    });
  };

  buscarMaisProspectos() {
    if (this.state.tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao') {
      this.buscarMaisProspectosModoTerrenoConstrucao();
    } else {
      const quantidadeDeProspectos =
        this.state.filtros.quantidade_por_consulta || 0;
      const filtros = {
        ...this.state.filtros,
        ...this.defaultValues,
        quantidade_por_consulta: quantidadeDeProspectos + 50,
        codigo_prospecto_etapa: '',
        codigo_etapa_terreno_construcao: '',
        filtrar_prospectos_ja_inclusos: '',
        quantidade_por_etapa: 0,
        apenas_terreno_construcao: false,
        tipo_visao: this.state.layoutSelecionado,
      };
      this.obterDados(filtros, true);
    }
  }

  buscarMaisProspectosModoTerrenoConstrucao(etapa) {
    this.setState(
      {
        loadingEtapa: etapa ? etapa.descricao : '',
      },
      () => {
        const quantidadeDeProspectos =
          this.state.filtros.quantidade_por_consulta || 0;
        const filtros = {
          ...this.state.filtros,
          ...this.defaultValues,
          quantidade_por_consulta: quantidadeDeProspectos + 50,
          tipo_visao: this.state.layoutSelecionado,
          codigo_prospecto_etapa: '',
          codigo_etapa_terreno_construcao: '',
          filtrar_prospectos_ja_inclusos: '',
          quantidade_por_etapa: 0,
          apenas_terreno_construcao: true,
        };
        this.obterDados(filtros, true)
          .then(() => {
            this.setState({ loadingEtapa: '' });
          })
          .catch(error => {
            console.error('Erro ao obter dados:', error);
          });
      }
    );
  }

  buscarMaisProspectoPorEtapa = etapa => {
    if (etapa.codigo === 0) return;

    this.setState(
      prevState => ({
        contador: prevState.contador + 1,
        loadingEtapa: etapa.descricao,
      }),
      () => {
        const etapaAtualizada = this.state.etapasProspectos.find(
          e => e.codigo === etapa.codigo
        );
        const quantidadedeprospeto = this.state.filtros.quantidade_por_consulta;
        const filtros = {
          ...this.state.filtros,
          ...this.defaultValues,
          codigo_prospecto_etapa: etapaAtualizada.codigo,
          codigo_etapa_terreno_construcao: '',
          quantidade_por_etapa: 100,
          tipo_visao: this.state.layoutSelecionado,
          quantidade_por_consulta: quantidadedeprospeto + 10,
          filtro: null,
          filtrar_prospectos_ja_inclusos: (this.state.prospectos || [])
            .map(item => item.codigo)
            .join(',')
            .toString(),
          apenas_terreno_construcao: false,
        };

        this.obterDados(filtros)
          .then(() => {
            this.setState({ loadingEtapa: '' });
          })
          .catch(error => {
            console.error('Erro ao obter dados:', error);
          });
      }
    );
  };

  buscarMaisProspectoPorEtapaTerrenoConstrucao = etapa => {
    if (etapa.codigo === 0) return;

    this.setState(
      prevState => ({ contador: prevState.contador + 1 }),
      () => {
        const quantidadedeprospeto = this.state.filtros.quantidade_por_consulta;
        const filtros = {
          ...this.state.filtros,
          ...this.defaultValues,
          codigo_prospecto_etapa: '',
          codigo_etapa_terreno_construcao: etapa.codigo,
          tipo_visao: this.state.layoutSelecionado,
          quantidade_por_consulta: quantidadedeprospeto + 10,
          quantidade_por_etapa: 100,
          filtrar_prospectos_ja_inclusos: (this.state.prospectos || [])
            .map(item => item.codigo)
            .join(',')
            .toString(),
        };

        this.obterDados(filtros).catch(error => {
          console.error('Erro ao obter dados:', error);
        });
      }
    );
  };

  handleBuscarMaisProspecto = () => {
    this.props.applyFilter();
    if (this.state.filtros.filtro) {
      this.setState(
        {
          filtros: { ...this.state.filtros, quantidade_por_consulta: 0 },
        },
        () => {
          this.buscarMaisProspectos();
        }
      );
    } else {
      this.buscarMaisProspectos();
    }
  };

  toggleTipoFiltro = tipoFiltro => {
    if (tipoFiltro !== this.state.tipoFiltroEtapa) {
      if (tipoFiltro === 'etapaProspectoTerrenoConstrucao') {
        const statusEtapaProspectoTerrenoConstrucao = STATUS_ETAPAS_PROSPECTOS_TERRENO_CONSTRUCAO.map(
          etapa => ({
            ...etapa,
            pagina_atual: 1,
          })
        );
        const filtros = {
          ...this.state.filtros,
          quantidade_por_consulta: 0,
          tipo_visao: this.state.layoutSelecionado,
          codigo_prospecto_etapa: '',
          codigo_etapa_terreno_construcao: '',
          filtrar_prospectos_ja_inclusos: '',
          quantidade_por_etapa: 0,
        };

        this.setState(
          {
            statusEtapaProspectoTerrenoConstrucao,
            contador: 0,
            prospectos: null,
            carregandoEtapas: true,
            tipoFiltroEtapa: tipoFiltro,
            filtros: filtros,
          },
          () => {
            this.buscarMaisProspectos();
          }
        );
      } else if (tipoFiltro === 'etapaProspectoPadrao') {
        const filtros = {
          ...this.state.filtros,
          quantidade_por_consulta: 0,
          tipo_visao: this.state.layoutSelecionado,
          codigo_prospecto_etapa: '',
          codigo_etapa_terreno_construcao: '',
          filtrar_prospectos_ja_inclusos: '',
          quantidade_por_etapa: 0,
        };

        this.setState(
          {
            contador: 0,
            prospectos: null,
            carregandoEtapas: true,
            tipoFiltroEtapa: tipoFiltro,
            filtros: filtros,
          },
          () => {
            this.buscarMaisProspectos();
          }
        );
      }
    }
    this.setState({ tipoFiltroEtapa: tipoFiltro, carregandoEtapas: false });
  };

  atualizaCorretores = () => {
    let corretoresSelecionaveis = null;

    if (!AuthStorage.isGerente()) {
      corretoresSelecionaveis = this.props.corretores;
    } else {
      corretoresSelecionaveis = this.props.imobiliariasById[
        AuthStorage.getUser().usuario
      ].corretores;
    }

    this.setState({
      correttores: this.props.corretores,
      corretoresSelecionaveis,
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.corretores.length !== this.props.corretores.length) {
      this.atualizaCorretores();
    }
  }

  onProspectoCriado = async () => {
    await this.recarregarKanban();
  };

  onClickSelecionaCorretor = async codigoCorretor => {
    let { filtros } = this.state;
    filtros.codigo_corretor = codigoCorretor;
    filtros.pagina_atual = 1;
    filtros.filtro = null;
    filtros.filtrar_prospectos_ja_inclusos = null;
    filtros.tipo_visao = this.state.layoutSelecionado;

    filtros = {
      ...this.defaultValues,
      tipo_visao: this.state.layoutSelecionado,
    };
    this.setState({
      expandirCorretores: !codigoCorretor,
      contador: 0,
    });
    await this.obterDados(filtros);
  };

  setSearchActive = isSearchActive => this.setState({ isSearchActive });

  ordenarPorDataUltimaOcorrencia = (prospectos, direcao) => {
    direcao = direcao || 'asc';
    const lista = prospectos.concat([]);
    return lista.sort((a, b) => {
      const dataA = a.data_ultima_anotacao;
      const dataB = b.data_ultima_anotacao;

      if (!dataA && dataB) return -1;
      if (dataA && !dataB) return 1;
      if (!dataA && !dataB) return 0;

      const dataANova = new Date(dataA);
      const dataBNova = new Date(dataB);

      return direcao === 'asc' ? dataANova - dataBNova : dataBNova - dataANova;
    });
  };

  handleToggleOrdenacao = codigoColuna => {
    this.setState(prevState => {
      const direcaoAtual = prevState.ordenacaoColunas[codigoColuna];
      let novaDirecao = 'asc';
      if (direcaoAtual === 'asc') {
        novaDirecao = 'desc';
      } else if (direcaoAtual === 'desc') {
        novaDirecao = 'asc';
      }
      return {
        ordenacaoColunas: {
          ...prevState.ordenacaoColunas,
          [codigoColuna]: novaDirecao,
        },
      };
    });
  };

  onSubmitSearch = values => {
    this.props.applyFilter();
    this.obterDados(
      {
        codigo_prospecto_etapa: '',
        codigo_etapa_terreno_construcao: '',
        ...values,
        quantidade_por_consulta: 0,
        quantidade_por_etapa: 0,
        filtrar_prospectos_ja_inclusos: '',
        filtro_side_bar: '1',
        tipo_visao: this.state.layoutSelecionado,
      },
      true
    );
  };

  selecionarEmpreendimento = CodigoFamilia => {
    let prospectoAtivo = _find(
      this.state.prospectoCarregado.prospecto_empreendimento,
      {
        codigo_familia: Number(CodigoFamilia),
      }
    );

    this.setState({
      prospectoAtivo: {
        ...this.state.prospectoCarregado,
        ...prospectoAtivo,
      },
    });
  };

  agruparProspectosLodash = itens => {
    if (!itens) {
      return {};
    }
    const resultado = {};
    const ordenacao = this.state.ordenacaoColunas;

    STATUS_ETAPAS_PROSPECTOS.forEach(etapa => {
      resultado[etapa.codigo] = [];
    });

    itens.forEach(item => {
      const codigo = item['codigo_etapa_prospecto'];
      if (resultado.hasOwnProperty(codigo)) {
        resultado[codigo].push(item);
      }
    });

    Object.keys(resultado).forEach(codigo => {
      const direcao = ordenacao[codigo] || 'asc';
      resultado[codigo] = this.ordenarPorDataUltimaOcorrencia(
        resultado[codigo],
        direcao
      );
    });

    return resultado;
  };

  agruparProspectosTerrenoConstrucaoLodash = () => {
    const resultado = {};
    const ordenacao = this.state.ordenacaoColunas;
    const prospectos = this.state.prospectos || [];

    this.state.statusEtapaProspectoTerrenoConstrucao.forEach(etapa => {
      resultado[etapa.codigo] = [];
    });

    prospectos
      .filter(p => p.etapa_terreno_construcao !== 0)
      .forEach(item => {
        const codigo = item['etapa_terreno_construcao'];
        if (resultado.hasOwnProperty(codigo)) {
          resultado[codigo].push(item);
        }
      });

    Object.keys(resultado).forEach(codigo => {
      const direcao = ordenacao[codigo] || 'asc';
      resultado[codigo] = this.ordenarPorDataUltimaOcorrencia(
        resultado[codigo],
        direcao
      );
    });

    return resultado;
  };

  async obterDados(filtros, limparListaProspecto = false) {
    this.setState({
      carregandoEtapas: true,
      isSearchActive: false,
      prospectoAtivo: null,
    });

    let {
      prospectos,
      codigo_gerente: codigoGerente,
      codigo_corretor: codigoCorretor,
      codigo_prospecto_etapa: codigoProspectoEtapa,
      quantidade_prospectos: quantidadeProspectos,
      pagina_atual,
      quantidade_por_pagina: quantidadePorPagina,
      ultima_pagina: ultimaPagina,
      json_total_por_etapa: total_por_etapa,
      data_ultima_ocorrencia: data_ultima_ocorrencia,
    } = await api.consultarProspectos({
      ...filtros,
      tipo_visao: this.state.layoutSelecionado,
    });

    total_por_etapa = JSON.parse(total_por_etapa);

    const novosProspectos = limparListaProspecto
      ? prospectos
      : [...(this.state.prospectos || []), ...prospectos];

    filtros = { ...filtros, codigo_prospecto_etapa: '' };
    this.setState({
      filtros,
      prospectos: novosProspectos,
      carregandoProspectos: false,
      codigoGerente,
      codigoCorretor,
      codigoProspectoEtapa,
      quantidadeProspectos,
      pagina_atual,
      quantidadePorPagina,
      ultimaPagina,
      carregandoEtapas: false,
      totalPorEtapaProspecto: total_por_etapa,
    });
  }

  updateCardColumn = async (
    card,
    fromCol,
    toCol,
    toIndex,
    motivoDescarte = null,
    justificativa = null
  ) => {
    if (String(fromCol) === String(toCol)) return true;
    const codigo = card.codigo;
    const isBusy = this.state.updatingCards[codigo];
    if (isBusy) return false;

    this.setState(prev => ({
      carregandoProspectos: true,
      updatingCards: { ...prev.updatingCards, [codigo]: true },
    }));

    let request;

    try {
      if (
        this.state.tipoFiltroEtapa === 'etapaProspectoPadrao' ||
        !this.state.tipoFiltroEtapa
      ) {
        if (String(toCol) === '10') {
          if (!motivoDescarte) {
            toast.error('Selecione um motivo para descartar.');
            return false;
          }
          await api.removerEmpreendimento({
            codigo_prospecto: card.codigo,
            codigo_familia: card.codigo_familia,
            codigo_motivo_descarte: motivoDescarte,
            justificativa,
          });
          toast.success(
            'Empreendimento removido e etapa atualizada, recarregue a página para ver as alterações.'
          );
        } else if (String(toCol) !== '10') {
          request = await api.atualizarEtapaProspecto({
            codigo_prospecto: card.codigo,
            etapa_atual: fromCol,
            nova_etapa: toCol,
            codigo_familia: card.codigo_familia,
          });
        }
      } else if (
        this.state.tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
      ) {
        request = await api.atualizarEtapaConstrucaoProspecto({
          codigo_prospecto: card.codigo,
          etapa_atual: fromCol,
          nova_etapa: toCol,
        });
      }

      if (request && request.status == 200) {
        let index = this.state.prospectos.findIndex(
          p => p.codigo === card.codigo
        );
        if (index === -1) return true;

        let [prospecto] = this.state.prospectos.splice(index, 1);
        if (
          this.state.tipoFiltroEtapa === 'etapaProspectoPadrao' ||
          !this.state.tipoFiltroEtapa
        ) {
          prospecto.codigo_etapa_prospecto = toCol;
        } else if (
          this.state.tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
        ) {
          prospecto.etapa_terreno_construcao = toCol;
        }
        let novaLista = [prospecto, ...this.state.prospectos];
        this.setState({ prospectos: novaLista });
      }

      return true;
    } catch (err) {
      if (
        this.state.tipoFiltroEtapa === 'etapaProspectoPadrao' ||
        !this.state.tipoFiltroEtapa
      ) {
        if (String(toCol) === '10') {
          toast.error('Erro ao descartar ou atualizar etapa.');
        } else {
          toast.error('Erro ao atualizar a etapa do prospecto.');
        }
      } else {
        toast.error('Erro ao atualizar a etapa de construção.');
      }
      return false;
    } finally {
      this.setState(prev => {
        const next = { ...prev.updatingCards };
        delete next[codigo];
        return { updatingCards: next, carregandoProspectos: false };
      });
    }
  };

  handleCardMove = async ({
    source,
    destination,
    card,
    motivoDescarte,
    justificativa,
  }) => {
    const fromCol = source.droppableId; // id da etapa -:codigo da etapa
    const toCol = destination.droppableId; // id da etapa destino -:codigo da etapa destino
    const toIndex = destination.index;
    let cards = {};
    if (
      this.state.tipoFiltroEtapa === 'etapaProspectoPadrao' ||
      !this.state.tipoFiltroEtapa
    ) {
      cards = this.agruparProspectosLodash(this.state.prospectos);
    } else if (
      this.state.tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
    ) {
      cards = this.agruparProspectosTerrenoConstrucaoLodash();
    }

    const srcCards = Array.from(cards[fromCol]);
    srcCards.splice(source.index, 1);

    const destCards = Array.from(cards[toCol]);
    destCards.splice(toIndex, 0, card);

    try {
      await this.updateCardColumn(
        card,
        fromCol,
        toCol,
        toIndex,
        motivoDescarte,
        justificativa
      );
    } catch (error) {
      toast.error('Erro ao salvar a mudança.' + error.message);
    }
  };

  travarMovimentoEtapaProspecto = info => {
    if (info['flag_represado_bolsao'] === true) {
      return true;
    }
  };

  onResetSearch = () => {};

  handleShowModal = (etapa, tipo) => {
    this.setState({
      modal: { show: true, etapa, tipo },
    });
  };

  handleCloseModal = () => {
    this.setState({ modal: { ...this.state.modal, show: false } });
  };

  modalPreConfirmacaoDeBuscaEtapa = (etapa, tipo) => {
    const filtros = this.state.filtros;

    if (!filtros.filtro_side_bar) {
      this.buscarEtapaTipo(etapa, tipo);
      return;
    }

    this.setState({
      modal: { show: true, etapa, tipo },
    });
  };

  handleConfirmarBusca = () => {
    const { etapa, tipo } = this.state.modal;
    this.buscarEtapaTipo(etapa, tipo);
    this.handleCloseModal();
  };

  buscarEtapaTipo = (etapa, tipo) => {
    if (tipo === 'etapa-prospecto') {
      this.buscarMaisProspectoPorEtapa(etapa);
    } else if (tipo === 'etapa-construcao') {
      this.buscarMaisProspectosModoTerrenoConstrucao(etapa);
    }
  };

  render() {
    const {
      isSearchActive,
      filtros,
      carregandoEtapas,
      prospectos,
      corretoresSelecionaveis,
      tipoFiltroEtapa,
      carregandoProspectos,
      loadingEtapa,
      modal,
      totalPorEtapaProspecto,
    } = this.state;

    const { imobiliarias, empreendimentos, filterIsDirty } = this.props;

    const visualizarGerentes = AuthStorage.isADM();
    const visualizarCorretores = AuthStorage.isADM() || AuthStorage.isGerente();

    const CardProspectoComCallback = props => (
      <CardProspecto {...props} onStatusChange={this.recarregarKanban} />
    );

    return (
      <div className="bg-white h-100 overflow-hidden">
        <div className="">
          <ProspectosNavbar
            filterIsDirty={filterIsDirty}
            setSearchActive={this.setSearchActive}
            isSearchActive={isSearchActive}
            filtros={filtros}
            visualizarGerentes={visualizarGerentes}
            imobiliarias={imobiliarias}
            visualizarCorretores={visualizarCorretores}
            corretoresSelecionaveis={corretoresSelecionaveis}
            onSubmitSearch={this.onSubmitSearch}
            onResetSearch={this.onResetSearch}
            empreendimentos={empreendimentos}
            isLoading={carregandoEtapas}
            handleChangeFiltro={this.toggleTipoFiltro}
            tipoFiltroEtapa={tipoFiltroEtapa}
            layoutSelecionado={this.state.layoutSelecionado}
            onChangeLayout={this.onChangeLayout}
          />
        </div>

        {carregandoEtapas && !loadingEtapa && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <Loading label="Buscando prospectos..." />
          </div>
        )}

        {(!carregandoEtapas || loadingEtapa) && (
          <div className="h-100 overflow-hidden bg-white">
            {tipoFiltroEtapa === 'etapaProspectoPadrao' && (
              <KanbanBoard
                columns={STATUS_ETAPAS_PROSPECTOS.filter(
                  item =>
                    item.codigo !== 0 &&
                    (this.state.layoutSelecionado !== 'corretor' ||
                      ![1, 2, 3, 11].includes(item.codigo))
                ).map(item => {
                  let match = null;
                  if (totalPorEtapaProspecto) {
                    match = totalPorEtapaProspecto.find(
                      etapa => etapa.Codigo_Etapa === item.codigo
                    );
                  }
                  return { ...item, total: match };
                })}
                cards={this.agruparProspectosLodash(prospectos)}
                renderCard={CardProspectoComCallback}
                onCardMove={this.handleCardMove}
                acrescentarCards={etapa =>
                  this.modalPreConfirmacaoDeBuscaEtapa(etapa, 'etapa-prospecto')
                }
                isDragDisabled={this.travarMovimentoEtapaProspecto}
                disableOnSearch={carregandoProspectos}
                regraDeFluxo={REGRA_FLUXOGRAMA_ETAPA}
                loadingEtapa={loadingEtapa}
                handleChangeFiltro={this.toggleTipoFiltro}
                tipoFiltroEtapa={tipoFiltroEtapa}
                onToggleOrdenacao={this.handleToggleOrdenacao}
                ordenacaoColunas={this.state.ordenacaoColunas}
              />
            )}
            {tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao' && (
              <KanbanBoard
                columns={STATUS_ETAPAS_PROSPECTOS_TERRENO_CONSTRUCAO.filter(
                  item => item.codigo !== 0
                )}
                cards={this.agruparProspectosTerrenoConstrucaoLodash()}
                renderCard={CardProspectoComCallback}
                onCardMove={this.handleCardMove}
                acrescentarCards={etapa =>
                  this.modalPreConfirmacaoDeBuscaEtapa(
                    etapa,
                    'etapa-construcao'
                  )
                }
                isDragDisabled={this.travarMovimentoEtapaProspecto}
                disableOnSearch={carregandoProspectos}
                loadingEtapa={loadingEtapa}
                handleChangeFiltro={this.toggleTipoFiltro}
                tipoFiltroEtapa={tipoFiltroEtapa}
                onToggleOrdenacao={this.handleToggleOrdenacao}
                ordenacaoColunas={this.state.ordenacaoColunas}
              />
            )}
          </div>
        )}

        <Modal show={modal.show} onHide={this.handleCloseModal} centered>
          <Modal.Header
            closeButton
            style={{
              fontFamily: 'Open Sans, sans-serif',
              background: '#f8f9fa',
              borderBottom: 'none',
            }}
          >
            <Modal.Title
              style={{
                fontFamily: 'Open Sans, sans-serif',
                fontWeight: 700,
                color: '#d9534f',
              }}
            >
              Atenção
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              fontFamily: 'Open Sans, sans-serif',
              fontSize: 16,
              color: '#333',
              background: '#fffbe6',
              borderRadius: 8,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 12,
              }}
            >
              <span
                style={{
                  fontFamily: 'Open Sans, sans-serif',
                  fontSize: 18,
                  color: '#d9534f',
                  fontWeight: 400,
                }}
              >
                Esta ação irá apagar todos os filtros aplicados!
              </span>
              <span
                style={{
                  fontFamily: 'Open Sans, sans-serif',
                  fontSize: 15,
                  color: '#555',
                  marginTop: 6,
                }}
              >
                Tem certeza que deseja continuar? Os filtros atuais serão
                removidos e não será possível desfazer esta ação.
              </span>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              background: '#f8f9fa',
              borderTop: 'none',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div
              className="d-flex justify-content-between"
              style={{ width: '100%' }}
            >
              <Button
                variant="secondary"
                onClick={this.handleCloseModal}
                style={{
                  fontFamily: 'Open Sans, sans-serif',
                  minWidth: 110,
                  fontWeight: 600,
                }}
              >
                Cancelar
              </Button>
              <Button
                variant="danger"
                onClick={this.handleConfirmarBusca}
                style={{
                  fontFamily: 'Open Sans, sans-serif',
                  minWidth: 110,
                  fontWeight: 600,
                  marginLeft: 10,
                }}
              >
                Apagar Filtros
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <ModalAdicionarProspecto
          quandoCriarProspecto={this.onProspectoCriado}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  imobiliarias: state.corretor.listaGerentes,
  imobiliariasById: state.corretor.gerentesById,
  empreendimentos: state.empreendimentos,
  corretores: state.corretor.listaCorretores,
  corretoresById: state.corretor.corretoresById,

  gerentesCorretor: state.corretor, //TODO Refatorar
  filter: state.prospecto.filter,
  filterIsDirty: false,

  prospecto: state.prospecto,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ selecionarEmpreendimento, applyFilter }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardProspecto)
);
